import type { TMessages } from '@/types/TMessages'

export const messages = {
  placeholder: 'Адрес склада (для расчета цены)',
} satisfies TMessages
